import { Pipe, PipeTransform } from '@angular/core';
import { ImportContactState } from '@app-types/enums/contacts';

@Pipe({
  name: 'formatStateImportContact',
  standalone: true,
})
export class FormatStateImportContactPipe implements PipeTransform {
  transform(state: ImportContactState): string {
    switch (state) {
      case ImportContactState.Imported:
        return 'imported';
      case ImportContactState.Error:
        return 'importError';
      case ImportContactState.Missed:
        return 'importMissed';
      default:
        return '';
    }
  }
}
